import msg from "@/service/messages"

const messageService = {
  getMessage: function(key) {
    return msg[key];
  }
};
export default messageService;



// WEBPACK FOOTER //
// ./src/service/messageService.js